import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { Eyebrow, Plate } from '@/components/landing/primitives';
import { stagger } from '@/components/landing/stagger';
import { EMAIL, FACEBOOK_URL, LINE_OA_URL, PHONE_DISPLAY, PHONE_TEL, SECTION_IDS, mailto, premizeHref } from '@/content/site';

/**
 * The closing statement: the page's biggest heading after the hero, one
 * button (PreMize), and the two other doors as plain links that open an email
 * already titled, so the reply knows what it is about.
 */
export function ContactSection() {
  const channels = [
    { label: EMAIL, href: `mailto:${EMAIL}`, external: false },
    { label: PHONE_DISPLAY, href: PHONE_TEL, external: false },
    ...(LINE_OA_URL ? [{ label: 'LINE', href: LINE_OA_URL, external: true }] : []),
    { label: 'Facebook', href: FACEBOOK_URL, external: true },
  ];

  return (
    <Plate id="contact" labelledBy="contact-title" className="text-center">
      <Eyebrow text="Contact" n={SECTION_IDS.indexOf('contact')} className="justify-center" />
      <h2 id="contact-title" className="lp-h2 lp-h2--close lp-reveal mx-auto max-w-5xl" style={stagger(1)}>
        Tell us where your AI needs to run.
      </h2>
      <p className="lp-body lp-reveal mx-auto mt-6 max-w-2xl" style={stagger(2)}>
        Explore PreMize, or send us your idea. We’ll reply with next steps.
      </p>

      <div className="lp-reveal mt-10 flex justify-center" style={stagger(3)}>
        <a href={premizeHref('contact')} target="_blank" rel="noopener noreferrer" className="btn-primary">
          Explore PreMize <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>

      <div className="lp-reveal mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-10" style={stagger(4)}>
        <a href={mailto('Hybrid AI setup')} className="link-quiet">
          Plan a hybrid setup <ArrowRight className="h-4 w-4" />
        </a>
        <a href={mailto('Physical AI / Training')} className="link-quiet">
          Ask about robot kits and training <ArrowRight className="h-4 w-4" />
        </a>
      </div>

      <ul
        className="lp-reveal mt-16 flex flex-wrap justify-center gap-x-8 gap-y-2 text-[15px] text-muted-foreground"
        style={stagger(5)}
        aria-label="Other ways to reach us"
      >
        {channels.map((c) => (
          <li key={c.href}>
            <a
              href={c.href}
              {...(c.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              className="transition-colors hover:text-foreground"
            >
              {c.label}
            </a>
          </li>
        ))}
      </ul>
    </Plate>
  );
}
